module.exports = __webpack_public_path__ + "img/astral_7.df82d852.svg";